import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-accent/15 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-152" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-153" data-mp="2vppn17ywe6cr">
        <div className="text-center" data-id="element-154" data-mp="39hvywhv0pr6e">
          <SectionHeading id="problem-title" data-id="element-155" data-mp="39guq6k1h5gru">Ti suona <span className="text-accent" data-id="element-156" data-mp="39jqmy51l5zep">familiare?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-157" data-mp="35fr6fmgb30lc">
            Petrolio e gas sono ovunque nella vita dei tuoi studenti, ma trasformarli in lezioni chiare e coinvolgenti
            richiede tempo. Giacimenti, pozzi, oleodotti e raffinerie sono concetti difficili da visualizzare, e tu devi
            spiegarli senza materiali adeguati.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-accent/20 bg-background/55 p-6 shadow-lg shadow-black/30 backdrop-blur-md sm:p-8" data-id="element-158" data-mp="1k4ismn3cht2n">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-foreground" data-id="element-159" data-mp="x5jsxvgb4lvi">
            <AlertTriangleIcon className="h-5 w-5 text-highlight" aria-hidden="true" data-id="element-160" data-mp="122tjjeffn3kx" />
            Il vero problema:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-161" data-mp="174shu9wbfab0">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-162" data-mp="1c2alplvh6zc5">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-accent shadow-glow" aria-hidden="true" data-id="element-163" data-mp="1g22xs8k2vnm9" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-164" data-mp="3hvsib44bzts7">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-165" data-mp="3hwkae4ypz9dq">
            Non ti servono altre informazioni sparse.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-highlight sm:text-3xl" data-id="element-166" data-mp="k27iz9d6df4n">Ti serve un sistema organizzato e pronto per la classe.</p>
        </div>
      </div>
    </section>;
}